import { AUTH_TOKEN_KEY, TYPE_ACCOUNT_KEY, USER_NAME_KEY } from '@/core/constants/auth'
import { login } from '@/core/service/service'
import { base64Encode } from '@/core/utils/utils'
import { Button, CircularProgress, Paper, Stack, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router'

function LoginPage() {
    const [loginName, setLoginName] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()

    const handleLogin = async () => {
        setError('')
        setIsLoading(true)
        const userHash = base64Encode(`${loginName}:${password}`, true)

        try {
            const response = await login({ userHash })

            if (response.status === 200) {
                const data = response.data as { token?: string; href?: string }
                const token = data?.token ?? ''

                if (token) {
                    localStorage.setItem(AUTH_TOKEN_KEY, token)
                    localStorage.setItem(TYPE_ACCOUNT_KEY, 'employees')
                    localStorage.setItem(USER_NAME_KEY, loginName)
                    navigate('/mlm/distributor', { replace: true })
                } else {
                    setIsLoading(false)
                    
                    throw new Error('Tên Đăng Nhập hoặc Mật Khẩu không tồn tại')
                }
            } else {
                setIsLoading(false)
                setError(response.data.message)
            }
        } catch (error) {
            console.log('e', error)
            setIsLoading(false)
            setError('Tên Đăng Nhập hoặc Mật Khẩu không tồn tại')
        }
    }

    return (
        <Stack
            component="section"
            alignItems="center"
            justifyContent="center"
            spacing={3}
            sx={{
                flex: 1,
                minHeight: '100vh',
                minWidth: '100vw',
                p: { xs: 3, md: 6 },
                backgroundColor: '#343a40'
            }}>
            <Typography variant="h5" fontWeight={600} color="common.white" textAlign="center">
                Unicity Marketing Việt Nam
            </Typography>
            <Paper
                elevation={3}
                sx={{
                    width: '100%',
                    maxWidth: 540,
                    p: { xs: 3, md: 4 },
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                    borderRadius: 3
                }}>
                <Stack spacing={2.5}>
                    <Stack spacing={0.75}>
                        <Typography variant="subtitle2" fontWeight={600} color="text.primary">
                            Tên Đăng Nhập
                        </Typography>
                        <TextField
                            placeholder="Username"
                            value={loginName}
                            onChange={event => setLoginName(event.target.value)}
                            fullWidth
                        />
                    </Stack>
                    <Stack spacing={0.75}>
                        <Typography variant="subtitle2" fontWeight={600} color="text.primary">
                            Mật Khẩu
                        </Typography>
                        <TextField
                            placeholder="Password"
                            type="password"
                            value={password}
                            onChange={event => setPassword(event.target.value)}
                            onKeyDown={event => {
                                if (event.key === 'Enter') {
                                    handleLogin()
                                }
                            }}
                            fullWidth
                        />
                    </Stack>
                </Stack>

                {error && (
                    <Typography sx={{ color: 'red', textAlign: 'center' }} fontWeight={600}>
                        {error}
                    </Typography>
                )}

                <Button 
                    variant="contained" 
                    color="success" 
                    size="large" 
                    onClick={handleLogin}
                    disabled={isLoading} 
                    sx={{
                        backgroundColor: '#28a745',
                        height: 45,
                    }}>
                    {isLoading ? <CircularProgress size={20} /> : 'Đăng Nhập'}
                </Button>
            </Paper>
        </Stack>
    )
}

export default LoginPage

